import { ListView, TopBarRoute } from "components/templates";
import { UpsertModal, useSearch } from "../../../foundation";
import { IconPickerIcon, ListRow } from "../../../components/organisms";
import { useNavigate } from "react-router";
import { Button, Stack, Title } from "@introist/react-foundation/v2";
import { useState } from "react";
import { TaskCreate, useTaskActions, useTasks } from "../useTasks";
import { TaskForm } from "../TaskForm";

export const TasksListRoute = () => {
  const navigate = useNavigate();

  const { tasks } = useTasks();
  const { create } = useTaskActions();

  const { filtered, search, setSearch } = useSearch(tasks, { fields: ["title"] });

  const [createOpen, setCreateOpen] = useState(false);

  return (
    <TopBarRoute
      paths={[
        {
          key: "root",
          title: "Tasks",
          onClick: () => navigate("/tasks")
        }
      ]}
      medium
    >
      <Stack vertical gap="xLarge">
        <ListView.Header
          title="Tasks"
          count={tasks?.length}
          search={{ search, setSearch }}
          onCreate={() => setCreateOpen(true)}
        />
        <ListView.List
          data={filtered}
          empty={
            tasks && tasks.length === 0
              ? {
                  icon: "check",
                  title: "Track task completion with Tasks",
                  message:
                    "Create tasks, embed them in automation messages, and see who completed them.",
                  action: <Button onClick={() => setCreateOpen(true)}>Create Task</Button>
                }
              : { icon: "check" }
          }
          renderRow={task => (
            <ListRow
              gridTemplateColumns="1fr"
              clickable
              onClick={() => navigate(`/tasks/${task.id}`)}
            >
              <Stack>
                <IconPickerIcon icon="check" fallbackIcon="check" />
                <Title variant="bold">{task.title}</Title>
              </Stack>
            </ListRow>
          )}
        />
      </Stack>
      <UpsertModal
        open={createOpen}
        onClose={() => setCreateOpen(false)}
        onCreate={async entry => {
          await create(entry as TaskCreate).then(created => navigate(`/tasks/${created.id}`));
        }}
        onUpdate={() => {
          throw new Error("Not implemented");
        }}
        Form={TaskForm}
        entryName="Task"
      />
    </TopBarRoute>
  );
};
